const getFavoriteName = langs => {
  if (langs.length > 0) {
    let getDefault = langs.find(n => n.default);
    return getDefault ? getDefault : langs[0];
  }
  return false;
};

const getNameValue = (names, lang) => {
  let nm = names.find(n => n.id === lang.id) || [];
  if (nm) {
    return nm.value;
  }
  return "";
};

const getTableData = (list, langs) => {
  return list.map(item => {
    return {
      id: item.id,
      code: item.code,
      name: getNameValue(item.names, getFavoriteName(langs)),
      names: item.names,
      noTranslationRequired: item.noTranslationRequired,
      type: item.attributeType,
      comment: item.comment
    };
  });
};

const getAttribute = (tableData, id) => {
  let item = tableData.find(item => item.id === id);
  if (item) {
    let result = {
      id: item.id,
      code: item.code,
      noTranslationRequired: item.noTranslationRequired,
      comment: item.comment,
      type: item.type.type
    };

    if (item.type.length) {
      result.size = item.type.length;
    }
    if (item.type.lookUpId) {
      result.lookup = item.type.lookUpId;
    }
    if (item.type.multiSelect) {
      result.multiSelect = item.type.multiSelect;
    }

    item.names.forEach(name => {
      result[name.id] = name.value;
    });

    return result;
  }
  return null;
};

const prepareToSave = (obj, languages) => {
  let result = {
    code: obj.code,
    names: [],
    noTranslationRequired: obj.noTranslationRequired,
    comment: obj.comment,
    attributeType: {
      type: obj.type
    }
  };

  languages.forEach(lang => {
    if (obj[lang.id] !== undefined) {
      result.names.push({
        id: lang.id,
        value: obj[lang.id]
      });
    }
  });

  if (obj.size) {
    result.length = obj.size;
  }

  if (obj.size) {
    result.attributeType.length = obj.size;
  }

  if (obj.lookup) {
    result.attributeType.lookUpId = obj.lookup;
  }

  if (obj.multiSelect) {
    result.attributeType.multiSelect = obj.multiSelect;
  }

  return obj.id === undefined ? { data: result } : { id: obj.id, data: result };
};

export { getTableData, getAttribute, prepareToSave };
